import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';
import { NudgeType } from '../enums/NudgeType';
import CongratsBackground from '../assets/NudgeCongratsBackground.png';
import ReminderBackground from '../assets/NudgeReminderBackground.png';
import GuideBackground from '../assets/NudgeGuideBackground.png';

export type NudgeModalDetails = {
  title: JSX.Element;
  subTitle: JSX.Element;
  description: JSX.Element;
  details: JSX.Element;
  buttonText: JSX.Element;
  buttonIcon?: JSX.Element;
  backgroundImage: string;
};

export const nudgeModalDetailsMap: Record<NudgeType, NudgeModalDetails> = {
  [NudgeType.CONGRATS]: {
    title: <NamedContentEntryText container="span" refKey="managerCongratulateNudgeDialog" subKey="title" />,
    subTitle: <NamedContentEntryText container="span" refKey="managerCongratulateNudgeDialog" subKey="subtitle" />,
    description: (
      <NamedContentEntryText container="span" refKey="managerCongratulateNudgeDialog" subKey="firstRowMessage" />
    ),
    details: (
      <NamedContentEntryText container="span" refKey="managerCongratulateNudgeDialog" subKey="secondRowMessage" />
    ),
    buttonText: <NamedContentEntryText container="span" refKey="managerCongratulateNudgeDialog" subKey="thankYou" />,
    backgroundImage: CongratsBackground,
  },
  [NudgeType.GUIDANCE]: {
    title: <NamedContentEntryText container="span" refKey="managerSendGuidanceNudgeDialog" subKey="title" />,
    subTitle: <NamedContentEntryText container="span" refKey="managerSendGuidanceNudgeDialog" subKey="subtitle" />,
    description: (
      <NamedContentEntryText container="span" refKey="managerSendGuidanceNudgeDialog" subKey="firstRowMessage" />
    ),
    details: (
      <NamedContentEntryText container="span" refKey="managerSendGuidanceNudgeDialog" subKey="secondRowMessage" />
    ),
    buttonText: <NamedContentEntryText container="span" refKey="managerSendGuidanceNudgeDialog" subKey="tips" />,
    backgroundImage: GuideBackground,
  },
  [NudgeType.REMINDER]: {
    title: <NamedContentEntryText container="span" refKey="managerTrainingNudgeDialog" subKey="title" />,
    subTitle: <NamedContentEntryText container="span" refKey="managerTrainingNudgeDialog" subKey="title" />,
    description: (
      <NamedContentEntryText container="span" refKey="managerTrainingNudgeDialog" subKey="firstRowMessage" />
    ),
    details: <NamedContentEntryText container="span" refKey="managerTrainingNudgeDialog" subKey="secondRowMessage" />,
    buttonText: <NamedContentEntryText container="span" refKey="managerTrainingNudgeDialog" subKey="goToTrainings" />,
    backgroundImage: ReminderBackground,
  },
};
